module.exports = __webpack_public_path__ + "static/media/1008.9ee957e6.jpg";